import { Injectable } from "@angular/core";
@Injectable()
export class RandomColors {
    public colors = [
        'CornflowerBlue', 'LightCoral', 'Tomato', 'Moccasin', 'DarkSeaGreen',
        'LightGreen', 'YellowGreen', 'DimGray', 'RosyBrown', 'PowderBlue',
        'Tan', 'BurlyWood', 'IndianRed', 'Coral', 'Silver', 'DarkSlateGray',
        'MediumAquamarine', 'DarkSalmon', 'PaleTurquoise', 'Thistle',
        'LightYellow', 'SandyBrown', 'LightSlateGray', 'LightSkyBlue',
        'DarkOliveGreen', 'Peru', 'Khaki', 'PaleGoldenrod', 'Beige', 'LightPink', 'LightGray'
    ];

    public hexColors = [
        '#fc0564',
        '#ba7574',
        '#d07f58',
        '#de1a11',
        '#d44c3f',
        '#0c7bd1',
        '#7decec',
        '#b94ea1',
        '#7beb0d',
        '#8c6813',
        '#aa74f6',
        '#e2a919',
        '#ff0aa5',
        '#905ac5',
        '#187a47',
        '#d2994d',
        '#cd0376',
        '#639874',
        '#93b6d3',
        '#8c6a76',
        '#a7d004',
        '#bd65a2',
        '#f5e24f',
        '#ef2aff',
        '#1d7cb6',
        '#198e6a',
        '#65ed1e',
        '#b5afe8',
        '#f0edba',
        '#c2f208'
    ];
}
